import { Dispatch } from "redux";
import { IDType } from "../../config/types";
import { defaultGet, defaultGetV2, fetchError } from "./all";
import { ManOfTheMatchService, MatchLocationEnum, SportEnum, TeamOfTheWeekLineup } from "../../client/api";
import { MatchActions, MatchActionTypes } from "./types";
import client from "../../client";


export function fetchMatchDays(
  dispatch: Dispatch<MatchActions>,
  aoi: IDType,
  sports: SportEnum
) {
  defaultGet(dispatch,
    MatchActionTypes.FETCH_SUCCESS_MATCH_DAYS,
    MatchActionTypes.FETCH_ERROR,
    MatchActionTypes.FETCH_MATCH_DAYS,
    client().getMatchDays,
    false,
    false,
    aoi,
    sports);
}

export function getLineupOfMatch(
  dispatch: Dispatch<MatchActions>,
  matchID: IDType,
  team: MatchLocationEnum
) {
  defaultGet(
    dispatch,
    MatchActionTypes.FETCH_LINEUP_SUCCESS,
    MatchActionTypes.FETCH_ERROR,
    MatchActionTypes.FETCH_LINEUP,
    client().getLineup,
    false,
    { id: matchID, date: team === "home" ? 1 : 2 },
    matchID,
    team
  );
}

export function fetchTotw(
  dispatch: Dispatch<MatchActions>,
  leagueId: IDType,
  matchDay: number
) {
  dispatch({ type: MatchActionTypes.FETCH_TOTW });
  ManOfTheMatchService.getTeamOfTheWeekManOfTheMatchTeamLeagueIdMatchdayMatchDayGet(
    leagueId as number,
    matchDay as number
  ).then(
    (response: TeamOfTheWeekLineup | null) => {
      dispatch({
        type: MatchActionTypes.FETCH_TOTW_SUCCESS,
        payload: {
          id: leagueId,
          date: matchDay,
          response,
          fetchDate: new Date()
        }
      });
    },
    (e) => fetchError(e, MatchActionTypes.FETCH_ERROR, dispatch)
  );
}

export function fetchMatchScreen(
  dispatch: Dispatch<MatchActions>,
  matchId: IDType
) {
  defaultGetV2(
    dispatch,
    MatchActionTypes.FETCH_SUCCESS_MATCH_SCREEN,
    MatchActionTypes.FETCH_ERROR,
    MatchActionTypes.FETCH_MATCH_SCREEN,
    client().getMatchScreen,
    false,
    { key: `${matchId}` },
    matchId
  );
}

export function fetchTeamMatches(
  dispatch: Dispatch<MatchActions>,
  teamId: IDType
) {
  defaultGetV2(
    dispatch,
    MatchActionTypes.FETCH_SUCCESS_TEAM_MATCHES,
    MatchActionTypes.FETCH_ERROR,
    MatchActionTypes.FETCH_TEAM_MATCHES,
    client().getTeamMatches,
    false,
    { key: `${teamId}` },
    teamId
  );
}

export function fetchLeagueMatches(
  dispatch: Dispatch<MatchActions>,
  leagueId: IDType
) {
  defaultGetV2(
    dispatch,
    MatchActionTypes.FETCH_SUCCESS_LEAGUE_MATCHES,
    MatchActionTypes.FETCH_ERROR,
    MatchActionTypes.FETCH_LEAGUE_MATCHES,
    client().getLeagueMatches,
    false,
    { key: `${leagueId}` },
    leagueId
  );
}

export function fetchSubCategoryMatches(
  dispatch: Dispatch<MatchActions>,
  subCatId: IDType,
  aoi: IDType
) {
  defaultGetV2(
    dispatch,
    MatchActionTypes.FETCH_SUCCESS_LEAGUE_MATCHES,
    MatchActionTypes.FETCH_ERROR,
    MatchActionTypes.FETCH_LEAGUE_MATCHES,
    client().getSubcategoryMatches,
    false,
    { key: `${subCatId}-${aoi}` },
    subCatId,
    aoi
  );
}


export function fetchHomeMatches(
  dispatch: Dispatch<MatchActions>,
  aoi: IDType,
  sports: SportEnum,
  date: string
) {
  defaultGetV2(
    dispatch,
    MatchActionTypes.FETCH_HOME_MATCHES_SUCCESS,
    MatchActionTypes.FETCH_ERROR,
    MatchActionTypes.FETCH_HOME_MATCHES,
    client().getHomeMatches,
    false,
    { key: `${aoi}-${sports}-${date}` },
    aoi,
    date,
    sports
  );
}
